import InviteList from "../../../components/invite/InviteList";

const Widget = () => {
  return <InviteList />;
};

export default Widget;
